import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet-async";
import { nimbleFavicon } from "@src/config/nimble";
import { fgfFavicon } from "@src/config/fgf";

const Favicon = ({ isNimbleSite }) => {
  const siteMeta = {
    favicon: isNimbleSite ? nimbleFavicon : fgfFavicon,
    title: isNimbleSite ? "Nimble" : "Fair Go Finance",
  };

  return (
    <Helmet>
      <link rel="icon" href={siteMeta.favicon} />
      <meta name="description" content={`${siteMeta.title} | Apply Now`} />
    </Helmet>
  );
};

export default Favicon;

Favicon.propTypes = {
  isNimbleSite: PropTypes.bool,
};
